import { useChat } from "@/providers/chat-provider";
import ChatItem from "./chat-item";

const PinnedChats = ({ showGroupChats = true }: { showGroupChats?: boolean }) => {
	const { inbox, pinnedChatUniqueIds } = useChat();

	const pinnedChats = inbox?.chats
		?.filter((chat) => (showGroupChats ? chat.type === "group" : chat.type === "direct"))
		?.filter((chat) => pinnedChatUniqueIds.includes(chat.uniqueChatId))
		?.sort(
			(a, b) =>
				pinnedChatUniqueIds.indexOf(a.uniqueChatId) - pinnedChatUniqueIds.indexOf(b.uniqueChatId)
		);

	return (
		<>
			{pinnedChats && pinnedChats.length > 0
				? pinnedChats?.map((chat) => (
						<ChatItem
							logo={chat?.logo}
							key={chat.uniqueChatId}
							timestamp={chat?.timestamp}
							lastMessage={chat?.lastMessage}
							isSuggestion={chat?.suggestion}
							uniqueChatId={chat?.uniqueChatId}
							name={
								chat?.recipient?.name
									? chat?.recipient?.name
									: chat.type === "group"
									? "Group"
									: "User"
							}
							onlineUsersCount={chat?.onlineUsersCount}
							recipient={chat?.recipient}
							isGroup={chat.type === "group"}
						/>
				  ))
				: null}
		</>
	);
};

export default PinnedChats;
